export interface Route {
    name: string;
    path: string;
    icon?: string;
    subroutes?: Route[];
    isSelected?: boolean;
}
export enum DefaultRoutes {
    home = "/home",
    dataVisualization = "/data-visualization",
    user = "/user",
    favorites = "/favorites",
    tasks = "/tasks",
    admin = "/admin",
    help = "/help",
    chat = "/chat",
    useReport = "/use-report",
    knowledgeBank = "/knowledge-bank"
}

export enum FeatureRoutes {
    reports = "/reports",
    boards = "/boards",
    chat = "/chat",
    useReport = "/use-report",
    exploreKnowledgeBank = "/explore",
    uploadDocumentsKnowledgeBank = "/upload-documents"
}

export const Routes: Route[] = [
    {
        name: 'Inicio',
        path: DefaultRoutes.home,
        icon: 'assets/icons/home.svg'
    },
    {
        name: 'Tipos de información',
        path: DefaultRoutes.dataVisualization,
        icon: 'assets/icons/analytics.svg',
        subroutes: [
            {
                name: 'Reportes',
                path: FeatureRoutes.reports,
            },
            {
                name: 'Tableros',
                path: FeatureRoutes.boards,
            },
            {
                name: 'Uso de reportes',
                path: DefaultRoutes.useReport,
            },
        ]
    },

    {
        name: 'Banco de conocimiento',
        path: DefaultRoutes.knowledgeBank,
        icon: 'assets/icons/folder.svg',
        subroutes: [
            {
                name: 'Explorar',
                path: FeatureRoutes.exploreKnowledgeBank,
            },
            {
                name: 'Subir documentos',
                path: FeatureRoutes.uploadDocumentsKnowledgeBank,
            },
        ]
    },

    {
        name: 'Favoritos',
        path: DefaultRoutes.favorites,
        icon: 'assets/icons/star.svg',
        subroutes: [
            {
                name: 'Reportes',
                path: FeatureRoutes.reports,
            },
            {
                name: 'Tableros',
                path: FeatureRoutes.boards,
            },
        ]
    },
    {
        name: 'Tareas',
        path: DefaultRoutes.tasks,
        icon: 'assets/icons/list-check.svg'
    },
    {
        name: 'Chat Gen BAI',
        path: DefaultRoutes.chat,
        icon: 'assets/icons/ia.svg'
    },
];

export const AdminRoutes: Route[] = [
    ...Routes,
    {
        name: 'Usuarios',
        path: `${DefaultRoutes.user}/registered`,
        icon: 'assets/icons/user.svg'
    },
    {
        name: 'Configuración',
        path: DefaultRoutes.admin,
        icon: 'assets/icons/settings.svg',
        subroutes: [
            {
                name: 'Parámetros lista',
                path: '/parameters',
            },
            {
                name: 'Grupos de reportes',
                path: '/report-groups',
            },
            {
                name: 'Areas Banco de conocimiento',
                path: '/area-knowledge-bank',
            },
            {
                name: 'Errores generación reporte',
                path: '/report-errors',
            },
            {
                name: 'Uso de reportes',
                path: DefaultRoutes.useReport,
            },
        ]
    },
]

export const SpecialistRoutes: Route[] = [
    ...Routes,
    {
        name: 'Usuarios',
        path: `${DefaultRoutes.user}/registered`,
        icon: 'assets/icons/user.svg',
    },
    {
        name: 'Configuración',
        path: DefaultRoutes.admin,
        icon: 'assets/icons/settings.svg',
        subroutes: [
            {
                name: 'Parametros lista',
                path: '/parameters',
            },
            {
                name: 'Grupos de reportes',
                path: '/report-groups',
            }
        ]
    },
]